import * as React from "react"
import Layout from "@/components/layout"
import Seo from "@/components/seo"
import { VideoSection } from "@/components"
import ClientReferral from "@/components/case/client-referral"
import OurPartner from "@/components/home/our-partner"
import AllCase from "@/components/case/all-case"
import t from "@/constants/wording"

const CasePage: React.FC = () => {
  // todo: Yixing - add seo data
  const ourPartnerText = {
    h1Text: "全球客户在 TiDB 上构建未来型企业",
    h5Text:
      "TiDB 现已被 3000 多家不同行业的领先企业应用在实际生产环境，探索它们是如何利用 TiDB 来破解业务挑战并走向成功的。",
  }

  return (
    <Layout>
      <Seo
        title={t("Case.PingCAP")}
        description={t(
          "As a converged database product positioned for online transaction processing/online analysis and processing"
        )}
        keywords={t("keywords")}
      />
      <OurPartner textContent={ourPartnerText} />
      <ClientReferral />
      <VideoSection />
      <AllCase />
    </Layout>
  )
}

export default CasePage
